// product countdown
function splitStr(string,seperator){
  return string.split(seperator);
}

function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      $(this).countdown(promoperiod, function(event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<span class="countdown"><span>%D</span><span class="time-txt">Days</span></span>' + '<span class="countdown"><span>%H</span><span class="time-txt">Hrs</span></span>' + '<span class="countdown"><span>%M</span><span class="time-txt">Min</span></span>' + '<span class="countdown"><span class="second">%S</span><span class="time-txt">Sec</span></span>'));
      });
    }
  });
}
countDownIni('.flip-countdown,.js-flip-countdown');

/* Scroll Horizontally */
function horizontalScroll(){
		const stickyContainer = document.querySelectorAll('.stickyscroll');
		var scrollingHorizontally = [];
		stickyContainer.forEach(function(postScroll, index) {
			scrollingHorizontally[index] = true;
			if (postScroll) {
				postScroll.addEventListener("wheel", (event) => {
					if (scrollingHorizontally[index]) {
						postScroll.scrollBy({
						left: event.deltaY < 0 ? -200 : 200,
						});
						event.preventDefault();

						// check if the user has reached the end of the slider
						if ( postScroll.scrollLeft >= postScroll.scrollWidth - postScroll.clientWidth ) {
							scrollingHorizontally[index] = false;
							postScroll.style.overflowY = "auto";
						}
					} else {
						scrollingHorizontally[index] = true;
						// (scroll the page up/down)
						return true;
					}
				});
			}
	});
}
$(document).ready(function() { horizontalScroll(); });
$(window).resize(function(){ horizontalScroll();} );

// header content 
 function headerContentAppend() {  
    if ($(window).width() < 990) {
       $(".header__inline-menu #base_mega_menu.responsive-menu").insertBefore(".header .header__heading");
       $(".header__inline-menu .vertical-menu-drawer-container #vertical-drawer").insertAfter("#base_mega_menu.responsive-menu .menu-drawer__navigation");
    }
   else{
      $(".header #base_mega_menu.responsive-menu").appendTo(".header__inline-menu .page-width");
      $("#base_mega_menu.responsive-menu .vertical-menu-drawer-container #vertical-drawer").appendTo(".header__inline-menu .header-bottom-menu .vertical-menu-drawer-container");
   }
 }
 $(document).ready(function() { headerContentAppend(); });
 $(window).resize(function(){ headerContentAppend();} );

// back to top
$(window).scroll(function() {
    if ($(this).scrollTop() > 500) {
        $('.top_button').fadeIn(500)
    } else {
        $('.top_button').fadeOut(500)
    }
});
$('.top_button').click(function(event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: 0
    }, 800)
});

// SFS fast page loader fix: covers the first paint only, then gets out of the way quickly.
// This prevents the oversized logo/menu flash without making the website feel slow.
(function() {
  var hidden = false;

  function hideSfsLoader() {
    if (hidden) return;
    hidden = true;

    var loader = document.querySelector('.ttloader');
    if (document.body) {
      document.body.classList.remove('sfs-loading');
    }
    if (!loader) return;

    loader.classList.add('hide-loader');
    setTimeout(function() {
      if (loader && loader.parentNode) {
        loader.style.display = 'none';
      }
    }, 220);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(hideSfsLoader, 80);
    }, { once: true });
  } else {
    setTimeout(hideSfsLoader, 80);
  }

  // Fast fallback: never let the loader make the site feel slow.
  setTimeout(hideSfsLoader, 900);
})();

// grid-list
$(document).ready(function() {
    $('.btn-group').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  }); 
  
 $(document).ready(function() {
    $('#col_1').click(function(event){event.preventDefault();$('#product-grid .grid__item').removeClass('grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop');$('#product-grid .grid__item').addClass('list-group-item');});
    $('#col_2').click(function(event){event.preventDefault();$('#product-grid .grid__item').removeClass('list-group-item grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop');$('#product-grid .grid__item').addClass('grid--2-col-desktop');});
    $('#col_3').click(function(event){event.preventDefault();$('#product-grid .grid__item').removeClass('list-group-item grid--2-col-desktop grid--4-col-desktop grid--5-col-desktop');$('#product-grid .grid__item').addClass('grid--3-col-desktop');});
    $('#col_4').click(function(event){event.preventDefault();$('#product-grid .grid__item').removeClass('list-group-item grid--2-col-desktop grid--3-col-desktop grid--5-col-desktop');$('#product-grid .grid__item').addClass('grid--4-col-desktop');});
    $('#col_5').click(function(event){event.preventDefault();$('#product-grid .grid__item').removeClass('list-group-item grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop');$('#product-grid .grid__item').addClass('grid--5-col-desktop');});
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    // Liquid normally renders pipe-separated options as split controls. This
    // browser-side upgrade is a safety net for cached sections or products
    // whose option data is returned differently by Shopify.
    this.upgradePipeSeparatedSelect();

    if (this.dataset.s2gSplitEnabled !== 'true') return;

    this.splitConfigurationInvalid = false;
    this.updateOptions();

    // Shopify intentionally caps product.variants in Liquid at 250. For large
    // shelving products we therefore use the server-selected variant object
    // instead of trying to find the selection inside that truncated array.
    if (this.isHighVariantProduct()) {
      this.currentVariant = this.getSelectedVariantData();
      this.updateSplitConfigurationUI();
      return;
    }

    this.updateMasterId();
    this.updateSplitConfigurationUI();
  }

  onVariantChange(event) {
    const splitControlChanged = Boolean(
      event && event.target && event.target.matches('[data-s2g-split-control]')
    );

    // Products with 250+ variants cannot be resolved from product.variants,
    // because Shopify only exposes the first 250 through that Liquid array.
    // Resolve these selections with option-value IDs + Section Rendering.
    if (this.isHighVariantProduct()) {
      this.onHighVariantChange(event, splitControlChanged);
      return;
    }

    if (splitControlChanged) {
      const changedComponentIndex = Number.parseInt(event.target.dataset.s2gSplitControl, 10);
      this.syncSplitConfiguration(changedComponentIndex);
    }

    this.updateOptions();

    // When another native option such as Base Size or Shelf Size changes,
    // keep the hidden combined option on a real variant for that selection.
    if (this.dataset.s2gSplitEnabled === 'true' && !splitControlChanged) {
      this.ensureValidSplitSelectionForNativeOptions();
      this.updateOptions();
    }

    this.updateSelectedOptionLabels();
    this.updateMasterId();

    if (this.splitConfigurationInvalid) {
      this.currentVariant = null;
    }

    this.updateSplitConfigurationUI();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
   
	
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateAvailability();
      this.updateSKU();
    }

    this.dispatchEvent(new CustomEvent('s2g:variant-changed', {
      bubbles: true,
      detail: { variant: this.currentVariant || null }
    }));
  }

  updateOptions() {
    const optionGroups = Array.from(this.querySelectorAll('[data-s2g-option-group]'));

    if (optionGroups.length) {
      this.options = optionGroups.map((group) => {
        const select = group.querySelector('select');
        if (select) return select.value;

        const checkedRadio = group.querySelector('input[type=\"radio\"]:checked');
        return checkedRadio ? checkedRadio.value : '';
      });
      return;
    }

    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateSelectedOptionLabels() {
    this.querySelectorAll('[data-s2g-option-group]').forEach((group) => {
      const selectedLabel = group.querySelector('[data-s2g-selected-value]');
      if (!selectedLabel) return;

      const select = group.querySelector('select');
      const checkedRadio = group.querySelector('input[type=\"radio\"]:checked');
      selectedLabel.textContent = select ? select.value : (checkedRadio ? checkedRadio.value : '');
    });
  }

  upgradePipeSeparatedSelect() {
    if (this.querySelector('[data-s2g-combined-select]')) return;

    const optionGroups = Array.from(this.querySelectorAll('[data-s2g-option-group]'));
    const candidateGroup = optionGroups.find((group) => {
      const select = group.querySelector('select');
      if (!select || select.options.length === 0) return false;

      const visibleLabel = group.querySelector('.s2g-variant-option__label span:first-child');
      const nameMatch = select.name.match(/^options\[(.*)\]$/);
      const optionName = visibleLabel ? visibleLabel.textContent.trim() : (nameMatch ? nameMatch[1].trim() : '');
      const labels = optionName.split('|').map((part) => part.trim());
      if (![2, 3].includes(labels.length) || labels.some((part) => !part)) return false;

      return Array.from(select.options).every((option) => {
        const parts = option.value.split('|').map((part) => part.trim());
        return parts.length === labels.length && parts.every(Boolean);
      });
    });

    if (!candidateGroup) return;

    const select = candidateGroup.querySelector('select');
    const visibleLabel = candidateGroup.querySelector('.s2g-variant-option__label span:first-child');
    const nameMatch = select.name.match(/^options\[(.*)\]$/);
    const optionName = visibleLabel ? visibleLabel.textContent.trim() : (nameMatch ? nameMatch[1].trim() : '');
    const labels = optionName.split('|').map((part) => part.trim());
    const componentCount = labels.length;
    const selectedParts = this.parseSplitConfiguration(select.value, componentCount);
    const position = Number.parseInt(candidateGroup.dataset.optionPosition, 10) ||
      optionGroups.indexOf(candidateGroup) + 1;

    candidateGroup.classList.add('s2g-native-combined-option');
    candidateGroup.setAttribute('aria-hidden', 'true');
    select.classList.add('s2g-native-combined-select');
    select.setAttribute('tabindex', '-1');
    select.dataset.s2gCombinedSelect = '';
    select.dataset.s2gCombinedPosition = String(position);
    select.dataset.s2gComponentCount = String(componentCount);

    Array.from(select.options).forEach((option) => {
      const parts = this.parseSplitConfiguration(option.value, componentCount);
      parts.forEach((part, componentIndex) => {
        option.dataset[`s2gComponent${componentIndex}`] = part || '';
      });
    });

    const splitWrapper = document.createElement('div');
    splitWrapper.className = 's2g-split-configuration';
    splitWrapper.dataset.s2gSplitConfiguration = '';
    splitWrapper.dataset.s2gComponentCount = String(componentCount);

    labels.forEach((labelText, componentIndex) => {
      splitWrapper.appendChild(
        this.createPipeSplitFieldset({
          labelText,
          componentIndex,
          selectedValue: selectedParts[componentIndex] || '',
          options: Array.from(select.options),
          position
        })
      );
    });

    const summary = document.createElement('div');
    summary.className = 's2g-selected-configuration';
    summary.dataset.s2gConfigurationSummary = '';
    summary.setAttribute('aria-live', 'polite');

    const icon = document.createElement('span');
    icon.className = 's2g-selected-configuration__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '✓';

    const summaryText = document.createElement('span');
    summaryText.dataset.s2gConfigurationSummaryText = '';
    summaryText.textContent = selectedParts.filter(Boolean).join(' · ');

    summary.append(icon, summaryText);
    splitWrapper.appendChild(summary);

    const unavailable = document.createElement('p');
    unavailable.className = 's2g-configuration-unavailable';
    unavailable.dataset.s2gConfigurationUnavailable = '';
    unavailable.setAttribute('role', 'status');
    unavailable.hidden = true;
    unavailable.textContent = 'This combination is unavailable. Please choose another option.';
    splitWrapper.appendChild(unavailable);

    candidateGroup.insertAdjacentElement('afterend', splitWrapper);
    this.classList.add('s2g-variant-picker--split-configuration');
    this.dataset.s2gSplitEnabled = 'true';
    this.dataset.s2gSplitOptionPosition = String(position);
    this.dataset.s2gSplitComponentCount = String(componentCount);
  }

  createPipeSplitFieldset({ labelText, componentIndex, selectedValue, options, position }) {
    const isColour = /colou?r/i.test(labelText);
    const fieldset = document.createElement('fieldset');
    fieldset.className = `s2g-variant-option s2g-split-option ${isColour ? 's2g-split-option--colour' : 's2g-split-option--buttons'} product-form__input`;

    const legend = document.createElement('legend');
    legend.className = 'form__label s2g-variant-option__label';

    const labelName = document.createElement('span');
    labelName.textContent = labelText;

    const selectedLabel = document.createElement('span');
    selectedLabel.className = 's2g-variant-option__selected';
    selectedLabel.dataset.s2gSplitSelected = String(componentIndex);
    selectedLabel.textContent = selectedValue;

    legend.append(labelName, selectedLabel);
    fieldset.appendChild(legend);

    const choices = document.createElement('div');
    choices.className = isColour ? 's2g-split-colour-list' : 's2g-split-button-list';
    choices.setAttribute('role', 'radiogroup');
    choices.setAttribute('aria-label', labelText);

    const uniqueValues = [];
    options.forEach((option) => {
      const parts = this.parseSplitConfiguration(option.value);
      const value = parts[componentIndex] || '';
      if (value && !uniqueValues.includes(value)) uniqueValues.push(value);
    });

    uniqueValues.forEach((value, valueIndex) => {
      const input = document.createElement('input');
      const safeSection = String(this.dataset.section || 'product').replace(/[^a-zA-Z0-9_-]/g, '-');
      const inputId = `S2G-Split-${safeSection}-${position}-${componentIndex}-${valueIndex}`;
      input.className = 's2g-variant-input';
      input.type = 'radio';
      input.id = inputId;
      input.name = `s2g-split-${safeSection}-${position}-${componentIndex}`;
      input.value = value;
      input.dataset.s2gSplitControl = String(componentIndex);
      input.checked = value === selectedValue;

      const choiceLabel = document.createElement('label');
      choiceLabel.htmlFor = inputId;
      choiceLabel.title = value;

      if (isColour) {
        choiceLabel.className = 's2g-split-colour-card';

        const swatch = document.createElement('span');
        swatch.className = 's2g-split-colour-card__swatch';
        swatch.setAttribute('aria-hidden', 'true');
        const background = this.getPipeSplitSwatchBackground(value);
        swatch.style.setProperty('--s2g-swatch-background', background);
        swatch.style.background = background;

        const name = document.createElement('span');
        name.className = 's2g-split-colour-card__name';
        name.textContent = value;
        choiceLabel.append(swatch, name);
      } else {
        choiceLabel.textContent = value;
      }

      choices.append(input, choiceLabel);
    });

    fieldset.appendChild(choices);
    return fieldset;
  }

  getPipeSplitSwatchBackground(value) {
    const name = String(value || '').trim().toLowerCase().replace(/[_-]+/g, ' ');

    if (name.includes('light jura')) return '#d8d5cc';
    if (name.includes('jura white')) return '#f1f0ea';
    if (name.includes('jura')) return '#e2dfd7';
    if (name.includes('chrome') || name.includes('silver') || name.includes('mirror')) {
      return 'linear-gradient(135deg, #ffffff 0%, #cbd5e1 28%, #64748b 50%, #f8fafc 72%, #94a3b8 100%)';
    }
    if (name.includes('walnut')) return 'linear-gradient(135deg, #5f3a23, #8a5a36 52%, #4a2c1b)';
    if (name.includes('maple')) return 'linear-gradient(135deg, #f0d4a6, #d6ad72 52%, #f5dfbb)';
    if (name.includes('oak')) return 'linear-gradient(135deg, #d6b27a, #a97b43 52%, #e3c394)';
    if (name.includes('beech')) return 'linear-gradient(135deg, #e8c58f, #c99b5b 52%, #f0d5a7)';
    if (name.includes('ash')) return 'linear-gradient(135deg, #ddd4c4, #b9aa93 52%, #eee8dd)';
    if (name.includes('black')) return '#111827';
    if (name.includes('dark grey') || name.includes('dark gray') || name.includes('charcoal')) return '#4b5563';
    if (name.includes('light grey') || name.includes('light gray')) return '#d1d5db';
    if (name.includes('grey') || name.includes('gray')) return '#9ca3af';
    if (name.includes('navy')) return '#172554';
    if (name.includes('blue')) return '#2563eb';
    if (name.includes('burgundy') || name.includes('maroon') || name.includes('dark red')) return '#7f1d1d';
    if (name.includes('red')) return '#dc2626';
    if (name.includes('green')) return '#16a34a';
    if (name.includes('yellow')) return '#facc15';
    if (name.includes('orange')) return '#f97316';
    if (name.includes('pink')) return '#ec4899';
    if (name.includes('purple') || name.includes('violet')) return '#7c3aed';
    if (name.includes('brown')) return '#8b5e3c';
    if (name.includes('cream') || name.includes('beige')) return '#f2e4c9';
    if (name.includes('white')) return '#ffffff';
    return '#e5e7eb';
  }

  isHighVariantProduct() {
    return this.dataset.s2gHighVariant === 'true';
  }

  getSelectedVariantData() {
    const script = this.querySelector('[data-s2g-selected-variant]');
    if (!script) return null;
    try {
      const value = script.textContent.trim();
      return value ? JSON.parse(value) : null;
    } catch (error) {
      console.warn('S2G: could not parse selected variant data', error);
      return null;
    }
  }

  getSelectedOptionValueIds() {
    return Array.from(this.querySelectorAll('[data-s2g-option-group]')).map((group) => {
      const select = group.querySelector('select');
      if (select) {
        const selected = select.options[select.selectedIndex];
        return selected ? (selected.dataset.optionValueId || '') : '';
      }

      const checked = group.querySelector('input[type="radio"]:checked');
      return checked ? (checked.dataset.optionValueId || '') : '';
    });
  }

  syncSplitConfigurationHighVariant(changedComponentIndex = -1) {
    const combinedSelect = this.getCombinedSelect();
    const selections = this.getSplitSelections();
    const componentCount = this.getSplitComponentCount();
    if (!combinedSelect || !selections || componentCount < 2 || selections.some((value) => !value)) return;

    const optionRecords = Array.from(combinedSelect.options).map((option) => ({
      option,
      parts: this.parseSplitConfiguration(option.value, componentCount)
    }));

    const exact = optionRecords.find(({ parts }) =>
      parts.length === componentCount &&
      selections.every((selection, componentIndex) => parts[componentIndex] === selection)
    );

    if (exact) {
      combinedSelect.value = exact.option.value;
      this.splitConfigurationInvalid = false;
      return;
    }

    // If a newly introduced colour does not yet have every EPOS combination,
    // keep the value the customer just chose and move only the later component
    // to the closest configuration that actually exists in Shopify's option list.
    const safeChangedIndex = Number.isFinite(changedComponentIndex)
      ? Math.max(0, Math.min(changedComponentIndex, componentCount - 1))
      : componentCount - 1;

    const candidates = optionRecords
      .filter(({ parts }) => {
        if (parts.length !== componentCount) return false;
        for (let index = 0; index <= safeChangedIndex; index += 1) {
          if (parts[index] !== selections[index]) return false;
        }
        return true;
      })
      .map((record) => {
        let score = 0;
        for (let index = safeChangedIndex + 1; index < componentCount; index += 1) {
          if (record.parts[index] === selections[index]) score += 1;
        }
        return { ...record, score };
      })
      .sort((a, b) => b.score - a.score);

    if (candidates.length) {
      combinedSelect.value = candidates[0].option.value;
      this.setSplitControlsFromCombinedValue(combinedSelect.value);
      this.splitConfigurationInvalid = false;
      return;
    }

    // No global combined option exists for the clicked value. Keep the last
    // real Shopify configuration rather than leaving the picker in a dead state.
    this.setSplitControlsFromCombinedValue(combinedSelect.value);
    this.splitConfigurationInvalid = false;
  }

  async onHighVariantChange(event, splitControlChanged) {
    const requestId = (this.s2gHighVariantRequestId || 0) + 1;
    this.s2gHighVariantRequestId = requestId;

    if (splitControlChanged) {
      const changedComponentIndex = Number.parseInt(event.target.dataset.s2gSplitControl, 10);
      this.syncSplitConfigurationHighVariant(changedComponentIndex);
    }

    this.updateOptions();
    this.updateSelectedOptionLabels();
    this.splitConfigurationInvalid = false;
    this.updateSplitConfigurationUI();
    this.removeErrorMessage();

    const result = await this.resolveHighVariantSelection(true);
    if (requestId !== this.s2gHighVariantRequestId) return;

    if (!result || !result.variant) {
      this.currentVariant = null;
      this.splitConfigurationInvalid = true;
      this.updateSplitConfigurationUI();
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      return;
    }

    this.currentVariant = result.variant;
    this.highVariantCombinedState = result.combinedState || [];

    const combinedSelect = this.getCombinedSelect();
    const combinedIndex = this.getCombinedOptionIndex();
    if (combinedSelect && combinedIndex >= 0 && this.currentVariant.options?.[combinedIndex]) {
      combinedSelect.value = this.currentVariant.options[combinedIndex];
      this.setSplitControlsFromCombinedValue(combinedSelect.value);
    }

    this.updateOptions();
    this.updateSelectedOptionLabels();
    this.splitConfigurationInvalid = false;
    this.updateSplitConfigurationUI();

    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateShareUrl();
    this.updateAvailability();
    this.updateSKU();

    this.dispatchEvent(new CustomEvent('s2g:variant-changed', {
      bubbles: true,
      detail: { variant: this.currentVariant }
    }));
  }

  async resolveHighVariantSelection(allowFallback = true) {
    const optionValueIds = this.getSelectedOptionValueIds();
    const expectedOptions = this.querySelectorAll('[data-s2g-option-group]').length;
    if (!expectedOptions || optionValueIds.length !== expectedOptions || optionValueIds.some((id) => !id)) {
      return null;
    }

    const sectionId = this.dataset.originalSection || this.dataset.section;
    const url = new URL(this.dataset.url, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('option_values', optionValueIds.join(','));

    try {
      const response = await fetch(`${url.pathname}${url.search}`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const sourcePicker = html.querySelector('variant-selects.s2g-variant-picker');
      if (!sourcePicker) return null;

      const sourceVariantScript = sourcePicker.querySelector('[data-s2g-selected-variant]');
      let variant = null;
      if (sourceVariantScript) {
        const raw = sourceVariantScript.textContent.trim();
        variant = raw ? JSON.parse(raw) : null;
      }

      const sourceCombined = sourcePicker.querySelector('[data-s2g-combined-select]');
      const componentCount = this.getSplitComponentCount();
      const combinedState = sourceCombined
        ? Array.from(sourceCombined.options).map((option) => ({
            value: option.value,
            parts: this.parseSplitConfiguration(option.value, componentCount),
            id: option.dataset.optionValueId || '',
            available: option.dataset.optionValueAvailable === 'true',
            hasVariant: option.dataset.optionValueHasVariant === 'true'
          }))
        : [];

      if (variant) return { variant, combinedState };

      // The requested combined value can exist globally but not for this Base
      // Width / Shelf Size pair. Ask Shopify which third-option values actually
      // map to a variant in this native-option context, choose the closest one,
      // then resolve once more.
      if (allowFallback && sourceCombined && combinedState.length) {
        const selections = this.getSplitSelections() || [];
        const realCandidates = combinedState.filter((record) => record.hasVariant);

        const ranked = realCandidates
          .map((record) => {
            let prefix = 0;
            let total = 0;
            for (let index = 0; index < selections.length; index += 1) {
              if (record.parts[index] === selections[index]) {
                total += 1;
                if (index === prefix) prefix += 1;
              }
            }
            return { record, prefix, total };
          })
          .sort((a, b) => {
            if (b.prefix !== a.prefix) return b.prefix - a.prefix;
            if (b.total !== a.total) return b.total - a.total;
            return Number(b.record.available) - Number(a.record.available);
          });

        if (ranked.length) {
          const combinedSelect = this.getCombinedSelect();
          const fallback = ranked[0].record;
          if (combinedSelect && combinedSelect.value !== fallback.value) {
            combinedSelect.value = fallback.value;
            this.setSplitControlsFromCombinedValue(fallback.value);
            this.updateOptions();
            return this.resolveHighVariantSelection(false);
          }
        }
      }

      return { variant: null, combinedState };
    } catch (error) {
      console.error('S2G high-variant resolution failed', error);
      return null;
    }
  }

  updateHighVariantSplitOptionAvailability() {
    const state = Array.isArray(this.highVariantCombinedState) ? this.highVariantCombinedState : [];
    const selections = this.getSplitSelections();

    // Before the first server refresh, do not falsely cross out options based on
    // Shopify's truncated 250-variant Liquid array.
    if (!state.length || !selections) {
      this.querySelectorAll('[data-s2g-split-control]').forEach((input) => {
        input.disabled = false;
        const label = input.nextElementSibling;
        if (label && label.tagName === 'LABEL') {
          label.classList.remove('is-unavailable');
          label.setAttribute('aria-disabled', 'false');
        }
      });
      return;
    }

    this.querySelectorAll('[data-s2g-split-control]').forEach((input) => {
      const componentIndex = Number.parseInt(input.dataset.s2gSplitControl, 10);
      const candidateValue = input.value.trim();

      const combinationExists = state.some((record) => {
        if (!record.hasVariant || record.parts[componentIndex] !== candidateValue) return false;
        for (let priorIndex = 0; priorIndex < componentIndex; priorIndex += 1) {
          if (selections[priorIndex] && record.parts[priorIndex] !== selections[priorIndex]) return false;
        }
        return true;
      });

      input.disabled = !combinationExists;
      const label = input.nextElementSibling;
      if (label && label.tagName === 'LABEL') {
        label.classList.toggle('is-unavailable', !combinationExists);
        label.setAttribute('aria-disabled', combinationExists ? 'false' : 'true');
      }
    });
  }

  getCombinedSelect() {
    return this.querySelector('[data-s2g-combined-select]');
  }

  getCombinedOptionIndex() {
    const combinedSelect = this.getCombinedSelect();
    if (!combinedSelect) return -1;

    const position = Number.parseInt(combinedSelect.dataset.s2gCombinedPosition, 10);
    return Number.isFinite(position) ? position - 1 : -1;
  }

  getSplitComponentCount() {
    const splitPicker = this.querySelector('[data-s2g-split-configuration]');
    const combinedSelect = this.getCombinedSelect();
    const explicitCount = Number.parseInt(
      (splitPicker && splitPicker.dataset.s2gComponentCount) ||
      (combinedSelect && combinedSelect.dataset.s2gComponentCount) ||
      this.dataset.s2gSplitComponentCount,
      10
    );

    if (Number.isFinite(explicitCount) && explicitCount >= 2) return explicitCount;

    const indexes = Array.from(this.querySelectorAll('[data-s2g-split-control]'))
      .map((input) => Number.parseInt(input.dataset.s2gSplitControl, 10))
      .filter(Number.isFinite);
    return indexes.length ? Math.max(...indexes) + 1 : 0;
  }

  getSplitSelections() {
    const splitPicker = this.querySelector('[data-s2g-split-configuration]');
    const componentCount = this.getSplitComponentCount();
    if (!splitPicker || componentCount < 2) return null;

    return Array.from({ length: componentCount }, (_, componentIndex) => {
      const checked = splitPicker.querySelector(
        `[data-s2g-split-control="${componentIndex}"]:checked`
      );
      return checked ? checked.value.trim() : '';
    });
  }

  parseSplitConfiguration(value, componentCount = 0) {
    const parts = String(value || '')
      .split('|')
      .map((part) => part.trim());

    return componentCount > 0 ? parts.slice(0, componentCount) : parts;
  }

  setSplitControlsFromCombinedValue(value) {
    const componentCount = this.getSplitComponentCount();
    const parts = this.parseSplitConfiguration(value, componentCount);
    const splitPicker = this.querySelector('[data-s2g-split-configuration]');
    if (!splitPicker || componentCount < 2 || parts.length < componentCount) return;

    Array.from({ length: componentCount }, (_, componentIndex) => componentIndex).forEach((componentIndex) => {
      splitPicker
        .querySelectorAll(`[data-s2g-split-control="${componentIndex}"]`)
        .forEach((input) => {
          input.checked = input.value.trim() === parts[componentIndex];
        });
    });
  }

  syncSplitConfiguration(changedComponentIndex = -1) {
    const combinedSelect = this.getCombinedSelect();
    const selections = this.getSplitSelections();
    const componentCount = this.getSplitComponentCount();
    const combinedIndex = this.getCombinedOptionIndex();

    if (
      !combinedSelect ||
      !selections ||
      componentCount < 2 ||
      combinedIndex < 0 ||
      selections.some((value) => !value)
    ) return;

    const variants = this.getVariantData();

    // Read the current native Shopify option values directly from the DOM.
    // This avoids stale option state while a split-control change is being handled.
    const optionGroups = Array.from(this.querySelectorAll('[data-s2g-option-group]'));
    const nativeSelections = optionGroups.map((group) => {
      const select = group.querySelector('select');
      if (select) return select.value;
      const checkedRadio = group.querySelector('input[type="radio"]:checked');
      return checkedRadio ? checkedRadio.value : '';
    });

    const matchesNativeOptions = (variant) => {
      return variant.options.every((optionValue, optionIndex) => {
        return optionIndex === combinedIndex || optionValue === nativeSelections[optionIndex];
      });
    };

    const variantsForNativeSelection = variants.filter(matchesNativeOptions);
    const partsForVariant = (variant) => this.parseSplitConfiguration(
      variant.options[combinedIndex],
      componentCount
    );

    // First preference: the customer's exact visible split selection exists.
    const exactVariant = variantsForNativeSelection.find((variant) => {
      const parts = partsForVariant(variant);
      return selections.every((selection, componentIndex) => {
        return parts[componentIndex] === selection;
      });
    });

    if (exactVariant) {
      combinedSelect.value = exactVariant.options[combinedIndex];
      this.splitConfigurationInvalid = false;
      return;
    }

    // A newly chosen component can make a later component invalid. For example,
    // Dark Grey may currently exist only with Silver EPOS. Preserve the newly
    // selected component and every component before it, then automatically move
    // later controls to the closest real Shopify combination instead of showing
    // "This combination is unavailable".
    const safeChangedIndex = Number.isFinite(changedComponentIndex)
      ? Math.max(0, Math.min(changedComponentIndex, componentCount - 1))
      : componentCount - 1;

    let fallbackCandidates = variantsForNativeSelection.filter((variant) => {
      const parts = partsForVariant(variant);
      for (let componentIndex = 0; componentIndex <= safeChangedIndex; componentIndex += 1) {
        if (parts[componentIndex] !== selections[componentIndex]) return false;
      }
      return true;
    });

    // Prefer the candidate that preserves as many of the remaining visible
    // selections as possible. Available variants win ties, but sold-out real
    // variants remain selectable so Shopify can show its normal stock state.
    fallbackCandidates = fallbackCandidates
      .map((variant) => {
        const parts = partsForVariant(variant);
        let score = 0;
        for (let componentIndex = safeChangedIndex + 1; componentIndex < componentCount; componentIndex += 1) {
          if (parts[componentIndex] === selections[componentIndex]) score += 1;
        }
        return { variant, score };
      })
      .sort((a, b) => {
        if (b.score !== a.score) return b.score - a.score;
        return Number(Boolean(b.variant.available)) - Number(Boolean(a.variant.available));
      });

    const fallbackVariant = fallbackCandidates.length ? fallbackCandidates[0].variant : null;

    if (fallbackVariant) {
      combinedSelect.value = fallbackVariant.options[combinedIndex];
      this.setSplitControlsFromCombinedValue(combinedSelect.value);
      this.splitConfigurationInvalid = false;
      return;
    }

    // If the newly clicked value cannot exist with the current native options,
    // safely revert the split controls to the last real combined Shopify value.
    const currentCombinedStillValid = variantsForNativeSelection.some((variant) => {
      return variant.options[combinedIndex] === combinedSelect.value;
    });

    if (currentCombinedStillValid) {
      this.setSplitControlsFromCombinedValue(combinedSelect.value);
      this.splitConfigurationInvalid = false;
      return;
    }

    const anyFallbackVariant = variantsForNativeSelection.find((variant) => variant.available) ||
      variantsForNativeSelection[0];

    if (anyFallbackVariant) {
      combinedSelect.value = anyFallbackVariant.options[combinedIndex];
      this.setSplitControlsFromCombinedValue(combinedSelect.value);
      this.splitConfigurationInvalid = false;
    } else {
      this.splitConfigurationInvalid = true;
    }
  }

  ensureValidSplitSelectionForNativeOptions() {
    const combinedSelect = this.getCombinedSelect();
    const combinedIndex = this.getCombinedOptionIndex();
    if (!combinedSelect || combinedIndex < 0 || !Array.isArray(this.options)) return;

    const variants = this.getVariantData();
    const matchesOtherNativeOptions = (variant) => {
      return variant.options.every((optionValue, optionIndex) => {
        return optionIndex === combinedIndex || optionValue === this.options[optionIndex];
      });
    };

    const currentSelectionIsValid = variants.some((variant) => {
      return matchesOtherNativeOptions(variant) &&
        variant.options[combinedIndex] === combinedSelect.value;
    });

    if (currentSelectionIsValid) {
      this.splitConfigurationInvalid = false;
      return;
    }

    const fallbackVariant = variants.find((variant) => {
      return matchesOtherNativeOptions(variant) && variant.available;
    }) || variants.find(matchesOtherNativeOptions);

    if (!fallbackVariant) {
      this.splitConfigurationInvalid = true;
      return;
    }

    combinedSelect.value = fallbackVariant.options[combinedIndex];
    this.setSplitControlsFromCombinedValue(combinedSelect.value);
    this.splitConfigurationInvalid = false;
  }

  updateSplitConfigurationUI() {
    const splitPicker = this.querySelector('[data-s2g-split-configuration]');
    const selections = this.getSplitSelections();
    if (!splitPicker || !selections) return;

    splitPicker.querySelectorAll('[data-s2g-split-selected]').forEach((label) => {
      const componentIndex = Number.parseInt(label.dataset.s2gSplitSelected, 10);
      if (Number.isFinite(componentIndex)) {
        label.textContent = selections[componentIndex] || '';
      }
    });

    const summaryText = splitPicker.querySelector('[data-s2g-configuration-summary-text]');
    if (summaryText) {
      summaryText.textContent = selections.filter(Boolean).join(' · ');
    }

    this.updateSplitOptionAvailability();

    const isUnavailable = Boolean(
      this.splitConfigurationInvalid ||
      selections.some((value) => !value) ||
      !this.currentVariant
    );
    const summary = splitPicker.querySelector('[data-s2g-configuration-summary]');
    const unavailableMessage = splitPicker.querySelector('[data-s2g-configuration-unavailable]');

    if (summary) summary.classList.toggle('is-unavailable', isUnavailable);
    if (unavailableMessage) unavailableMessage.hidden = !isUnavailable;
  }

  updateSplitOptionAvailability() {
    if (this.isHighVariantProduct()) {
      this.updateHighVariantSplitOptionAvailability();
      return;
    }

    const combinedIndex = this.getCombinedOptionIndex();
    const selections = this.getSplitSelections();
    const componentCount = this.getSplitComponentCount();
    if (combinedIndex < 0 || !Array.isArray(this.options) || !selections || componentCount < 2) return;

    const variants = this.getVariantData();

    this.querySelectorAll('[data-s2g-split-control]').forEach((input) => {
      const componentIndex = Number.parseInt(input.dataset.s2gSplitControl, 10);
      const candidateValue = input.value.trim();

      const combinationExists = variants.some((variant) => {
        const otherNativeOptionsMatch = variant.options.every((optionValue, optionIndex) => {
          return optionIndex === combinedIndex || optionValue === this.options[optionIndex];
        });
        if (!otherNativeOptionsMatch) return false;

        const parts = this.parseSplitConfiguration(
          variant.options[combinedIndex],
          componentCount
        );

        if (parts[componentIndex] !== candidateValue) return false;

        // Make availability flow from left to right. A Unit Colour is filtered
        // by the selected Number of Shelves; an EPOS Colour is filtered by both
        // shelves and Unit Colour. This prevents dead-end combinations while
        // still allowing a customer to change an earlier selector freely.
        for (let priorIndex = 0; priorIndex < componentIndex; priorIndex += 1) {
          if (selections[priorIndex] && parts[priorIndex] !== selections[priorIndex]) return false;
        }

        return true;
      });

      input.disabled = !combinationExists;
      const label = input.nextElementSibling;
      if (label && label.tagName === 'LABEL') {
        label.classList.toggle('is-unavailable', !combinationExists);
        label.setAttribute('aria-disabled', combinationExists ? 'false' : 'true');
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  
  updateSKU() {    
     $('.js-variant-sku').html(this.currentVariant && this.currentVariant.sku ? this.currentVariant.sku : 'N/A');
  }
  
  updateAvailability() {
    var $status = $('.js-variant-availability');
    if (!this.currentVariant) return;

    var text = 'Out of Stock';
    var statusClass = 'is-out-of-stock';

    if (this.currentVariant.available) {
      var qty = parseInt(this.currentVariant.inventory_quantity, 10);
      if (!isNaN(qty) && qty > 0 && qty <= 5) {
        text = 'Only ' + qty + ' Left';
        statusClass = 'is-low-stock';
      } else {
        text = 'In Stock';
        statusClass = 'is-in-stock';
      }
    }

    $status.removeClass('is-in-stock is-out-of-stock is-low-stock').addClass(statusClass);
    if ($status.find('.s2g-stock-text').length) {
      $status.find('.s2g-stock-text').html(text);
    } else {
      $status.html('<span class="s2g-stock-dot" aria-hidden="true"></span><span class="s2g-stock-text">' + text + '</span>');
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        if (window.SFSUpdateVatPrices) window.SFSUpdateVatPrices();
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    const script = this.querySelector('[data-s2g-variant-data]') || this.querySelector('[type="application/json"]');
    this.variantData = this.variantData || JSON.parse(script.textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);